module.exports = __webpack_public_path__ + "img/chat_emoticon_synot_004.png?540969da61fbc9c86ae13f549433877f";